export const basePath = "/hardship";

export const pathNames = {
  "/": "/",
  "personal-details": "personal-details",
  prescreening: "prescreening",
  accounts: "accounts",
  "reasons-for-applying": "reasons-for-applying",
  "your-income": "your-income",
  expenses: "expenses",
  liabilities: "liabilities",
  review: "review",
} as const;

export const REGION_APPLICATION_URL_MAP = {
  AU: "https://latitudefs.zendesk.com/hc/en-au/articles/360007986977-Appoint-or-Remove-an-Authorised-Third-Party",
  NZ: "https://www.gemfinance.co.nz/forms/?tlga=1050775476.1606880138&adobe_mc=MCMID%3D80601406305394606522238612776858100005%7CMCORGID%3DB6D9B74F57B2FBE97F000101%2540AdobeOrg%7CTS%3D1620768715&_ga=2.229336921.432380338.1620679002-1050775476.1606880138",
};

export const REGION_ON_HARDSHIP_LABEL_MAP = {
  AU: "Have you received Hardship Care in the last 24 months for any Latitude products?",
  NZ: "Have you received Hardship Care in the last 24 months for any Gem products?",
};

export const RIGHT_PLACE_MESSAGE_COPY = {
  AU: "If you’re applying for Hardship Care for an Australian account, you’re in the right place and should continue with this form. But if you have accounts in both Australia and New Zealand, you need to fill out separate applications for each region. You can apply for Hardship Care for a New Zealand account here",
  NZ: "If you’re applying for Hardship Care for a New Zealand account, you’re in the right place and should continue with this form. But if you have accounts in both Australia and New Zealand, you need to fill out separate applications for each region. You can apply for Hardship Care for an Australian account here.",
};

export const RIGHT_PLACE_LINK_COPY = {
  AU: "Apply for Hardship Care with Gem Finance New Zealand",
  NZ: "Apply for Hardship Care with Latitude Australia",
};

export const MAKE_CLAIM_URL_MAP = {
  AU: "https://www.latitudefinancial.com.au/insurance/make-a-claim/?tlga=1981343192.1613091776&adobe_mc=MCMID%3D16512140243906339811835594088126744128%7CMCORGID%3DB6D9B74F57B2FBE97F000101%2540AdobeOrg%7CTS%3D1617618003",
  NZ: "https://www.gemfinance.co.nz/insurance/make-a-claim/?_ga=2.219408157.568915857.1617618004-1981343192.1613091776",
};
